import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-recollectionmode',
  templateUrl: './recollectionmode.component.html',
  styleUrls: ['./recollectionmode.component.css']
})
export class RecollectionmodeComponent implements OnInit {
  recollection_mode: any;

  constructor() {
  }

  ngOnInit() {
  }

  selectPaymentMode() {
    //console.log('payment mode')
  }
}
